import React, { useState, useRef, useEffect } from 'react';
import { useGeneSearch } from '../../hooks/useGeneSearch';

export default function GeneSearch({ onSelectGene }) {
  const { query, setQuery, suggestions, resolve } = useGeneSearch();
  const [showSuggestions, setShowSuggestions] = useState(false);
  const inputRef = useRef(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowSuggestions(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const gene = resolve(query);
    if (gene) {
      onSelectGene(gene);
      setShowSuggestions(false);
    }
  };

  const handleSelect = (gene) => {
    setQuery(gene);
    onSelectGene(gene);
    setShowSuggestions(false);
  };

  return (
    <div className="gene-search" ref={wrapperRef}>
      <label>Gene Search</label>
      <form onSubmit={handleSubmit}>
        <input
          ref={inputRef}
          type="text"
          value={query}
          onChange={e => { setQuery(e.target.value); setShowSuggestions(true); }}
          onFocus={() => setShowSuggestions(true)}
          placeholder="e.g. Bcl6, Mll2..."
          spellCheck={false}
          autoComplete="off"
        />
      </form>
      {showSuggestions && suggestions.length > 0 && (
        <ul className="suggestions">
          {suggestions.map(({ gene, matchedAs }) => (
            <li key={gene} onClick={() => handleSelect(gene)}>
              <span className="gene-name">{gene}</span>
              {matchedAs && <span className="alias-tag">({matchedAs})</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
